exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_MediaSelectorUploadContainer_t32w_TRfedwlbaJg9Ww_V {\n  width: calc(100% - 10px);\n  height: 300px;\n  display: flex;\n  justify-content: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_MediaSelectorUploadContainer": "IA_MediaSelectorUploadContainer_t32w_TRfedwlbaJg9Ww_V"
};